import { ComponentProps } from 'react';
import { Input } from '@utilities-one/gpm-ui';

import { FormBase } from '@/library/form/components/FormBase';
import { useFieldContext } from '@/library/form/contexts';
import { FormControlProps } from '@/library/form/types/form.type';

type FormNumberInputProps = FormControlProps & {
  inputProps?: ComponentProps<typeof Input>;
};

/** Numeric form input bound to a `number | null` field (empty string ⇒ `null`, matching `z.number().nullable()` schemas). */
export function FormNumberInput({ inputProps, ...props }: FormNumberInputProps) {
  const field = useFieldContext<number | null>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;

  return (
    <FormBase {...props}>
      <Input
        type="number"
        inputMode="numeric"
        min={0}
        {...inputProps}
        id={field.name}
        name={field.name}
        value={field.state.value ?? ''}
        onBlur={field.handleBlur}
        onChange={(e) => {
          const raw = e.target.value;
          field.handleChange(raw === '' ? null : Number(raw));
        }}
        aria-invalid={isInvalid}
      />
    </FormBase>
  );
}
